import { ENVIRONMENT as uat } from './environment.uat';
import { ENVIRONMENT as uatId } from './environment.uat-id';

const envConfigs = [
  { hosts: ['v3uat.modalku.co.id'], environment: 'uat', envFile: uatId },
  { hosts: ['v3uat.fundingsocieties.com', 'v3uat.fundingsocieties.com.my', 'v3uat.fundingsocieties.co.th'], environment: 'uat', envFile: uat },
],
  envConfig = envConfigs.find(config => config.hosts.some(host => host === window.location.host));

let envValues;
let currentEnv;

if (envConfig?.environment) {
  // Statically defined environments. Eg., UAT
  envValues = envConfig.envFile;
  currentEnv = envConfig.environment;
} else {
  // Dynamically defined environments. Eg., preview
  const environment = localStorage.getItem('environment');

 if (environment === 'uat-id') {
    envValues = uatId;
    currentEnv = 'uat-id';
  } else {
    envValues = uat;
    currentEnv = 'uat';
  }
}

export const ENVIRONMENT = { ...envValues, selectedEnvironment: currentEnv };
